import { useEffect } from "react";

import { useSocketAuthenticated } from "../../SocketContext";
import api from "../../../../services/api";

const SocketStarredMessages = ({ dispatch }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const { getSocket } = useSocketAuthenticated();



  //  ****************
  //  ** Use Effect **
  //  ****************
  useEffect(() => {
    const socket = getSocket();

    if (socket) {
      const handleStarredMessage = (data) => {
        if ((data.action === "delete") && (`${api.defaults.headers.tenantId.toString()}` === `${data.tenantId.toString()}`)) {
          dispatch({ type: "DELETE_STARRED_MESSAGES", payload: data.starredMessageId });
        }
      };
  
      socket.on("starredMessages", handleStarredMessage);
  
      return () => {
        socket.off("starredMessages", handleStarredMessage);
      };
    }
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);


  
  //  ************
  //  ** Return **
  //  ************
  return (<></>);
};

export default SocketStarredMessages;